"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrForgotPasswordForm = void 0;
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const fdr_b2b_forgot_password_styles_1 = require("./fdr-b2b-forgot-password.styles");
function FdrForgotPasswordForm({ usernameLabel, validationSchema, onSubmit, }) {
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'auth']);
    return (react_1.default.createElement(formik_1.Formik, { validationSchema: validationSchema, initialValues: { username: '' }, onSubmit: onSubmit }, formik => {
        return (react_1.default.createElement(fdr_b2b_forgot_password_styles_1.FdrForgotPasswordFormWrapper, { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
            react_1.default.createElement("div", { className: "form-text" },
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "username", label: usernameLabel, showErrorMessage: true })),
            react_1.default.createElement(core_basis_bs_button_1.BsButton, { disabled: formik.isSubmitting, type: "submit", className: "form-submit-button" }, t('forms:submit.button'))));
    }));
}
exports.FdrForgotPasswordForm = FdrForgotPasswordForm;
//# sourceMappingURL=fdr-forgot-password-form.js.map